import { createRouter, createWebHistory } from 'vue-router'


const routes = [
	// ! MainLayout
	{
		path: '/',
		name: 'MainLayout',
		component: () => import('@/layouts/MainLayout'),
		redirect: { name: 'RepublicStatistic' },
		children: [
			{
				path: 'republic-statistic',
				name: 'RepublicStatistic',
				component: () => import('@/views/RepublicStatistic'),
			},
			{
				path: 'labor-resources',
				name: 'LaborResources',
				component: () => import('@/views/LaborResources'),
			},
			{
				path: 'employment',
				name: 'Employment',
				component: () => import('@/views/Employment'),
			},
			{
				path: 'professional-training',
				name: 'ProfessionalTraining',
				component: () => import('@/views/ProfessionalTraining'),
			},
			{
				path: 'public-works',
				name: 'PublicWorks',
				component: () => import('@/views/PublicWorks'),
			},
			{
				path: 'recognition-unemployed',
				name: 'RecognitionUnemployed',
				component: () => import('@/views/RecognitionUnemployed'),
			},
			{
				path: 'subsidy',
				name: 'Subsidy',
				component: () => import('@/views/Subsidy'),
			},
			{
				path: 'jobs',
				name: 'Jobs',
				component: () => import('@/views/Jobs'),
			},
			{
				path: 'migration',
				name: 'Migration',
				component: () => import('@/views/Migration'),
			},
			{
				path: 'state-inspection',
				name: 'StateInspection',
				component: () => import('@/views/StateInspection'),
			},
			{
				path: 'labor-system',
				name: 'LaborSystem',
				component: () => import('@/views/LaborSystem'),
			},
			{
				path: 'indicator',
				name: 'Indicator',
				component: () => import('@/views/Indicator'),
			},
			{
				path: 'kpi',
				name: 'KPI',
				component: () => import('@/views/KPI'),
			}
		]
	},
	// ! AuthLayout
	{
		path: '/auth',
		name: 'AuthLayout',
		component: () => import('@/layouts/AuthLayout'),
		redirect: { name: 'Login' },
		children: [
			{
				path: '',
				name: 'LoginWithToken',
				component: () => import('@/views/LoginWithToken'),
			},
			{
				path: 'login',
				name: 'Login',
				component: () => import('@/views/Login'),
			}
		]
	},
	// ! NotFound
	{
		path: '/:catchAll(.*)',
		redirect: '/'
	},
]

// Settings
const router = createRouter({
	history: createWebHistory(process.env.APP_URL),
	routes,
	scrollBehavior() {
		return { top: 0, left: 0 }
	},
})

export default router